import { HALLOWEEN_PROMO_GIFT_COUPON } from '../campaign';

/** Coupon code for new user free shipping (first order) */
export const NEW_USER_FREESHIP_COUPON_CODE = 'newfreeship';

/** @deprecated Use NEW_USER_FREESHIP_COUPON_CODE instead */
export const FREESHIPPING_COUPON_CODE = NEW_USER_FREESHIP_COUPON_CODE;

/** App exclusive coupon code - applied automatically when logged in on mobile app */
export const APP_EXCLUSIVE_COUPON_CODE = 'app20_skin_seoul';

/** Display name for app exclusive coupon (shown instead of actual code) */
export const APP_EXCLUSIVE_COUPON_DISPLAY_NAME = 'APP20';

/** Coupons that should be hidden from user interface but still functional */
export const HIDDEN_COUPONS_AT_DISCOUNT_SECTION = [APP_EXCLUSIVE_COUPON_CODE];

export const COUPONS_EXEMPT_FROM_LIMIT = [NEW_USER_FREESHIP_COUPON_CODE, HALLOWEEN_PROMO_GIFT_COUPON];

/**
 * Get display name for a coupon code
 * Returns the original code if no special display name is defined
 */
export const getCouponDisplayName = (couponCode: string): string => {
  if (couponCode === APP_EXCLUSIVE_COUPON_CODE) {
    return APP_EXCLUSIVE_COUPON_DISPLAY_NAME;
  }
  return couponCode;
};
